import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { UserManagementService } from './user-management.service';
import { NzMessageService } from 'ng-zorro-antd/message';
import { TranslateService } from '@ngx-translate/core';

export const columns = [
  { key: 'ntAccount', name: 'NT_ACCOUNT', visible: true },
  { key: 'name', name: 'USER_NAME', visible: true },
  { key: 'department', name: 'DEPARTMENT', visible: true },
  { key: 'email', name: 'EMAIL', visible: true },  
  { key: 'roleNameList', name: 'ROLES', visible: true },
  { key: 'updateTime', name: 'UPDATE_TIME', visible: true },
];

@Component({
  selector: 'app-user-management',
  templateUrl: './user-management.component.html',
  styleUrls: ['./user-management.component.scss']
})
export class UserManagementComponent implements OnInit {

  dataSource: any[] = [];
  columns: any[] = columns;
  widthConfig = ['150px','150px','150px','150px','265px','150px','120px'];
  pagination = {
    total: 50,
    pageIndex: 1,
    pageSize: 20,
    pageSizeOptions: [10, 20, 50],
  };
  params = {
    ntAccount: '',
    name: '',
    department: '',
    email: '',
  };
  
  roleList: any[] = [];
  
  isVisible = false;
  validateModuleForm!: FormGroup;
  isSpinning = false;

  constructor(
    private service: UserManagementService,
    private fb: FormBuilder,
    private message: NzMessageService,
    private translate: TranslateService,
    ) { }

  ngOnInit(): void {
    this.getRoleList();
    this.getList();
    this.validateModuleForm = this.fb.group({
      id: [null, []],
      ntAccount: [{ value: null, disabled: true }, [Validators.required]],
      name: [{ value: null, disabled: true }, [Validators.required]],
      department: [null, []],
      roleIds: [[], [Validators.required]], 
      email: [null, [Validators.required, Validators.email]],
    });
  }

  
  getRoleList() {
    this.service.getRoleList().subscribe(result => {
      const { rtnCode, rtnData } = result;
      if (rtnCode === 10000 && rtnData) {
        this.roleList = rtnData;
      }
     });
  }

  onSearch() {
    this.pagination.pageIndex = 1;
    this.getList();
  }

  onClear() {
    this.params = {
      ntAccount: '',
      name: '',
      department: '',
      email: '',
    };
    this.onSearch();
  }
  

  getList() {
    this.isSpinning = true;
    this.service.getTableList({ size: this.pagination.pageSize, current: this.pagination.pageIndex, param: this.params }).subscribe(result => {
      const { rtnCode, rtnData } = result;
      if (rtnCode === 10000) {
        const { rows, total } = rtnData;
        this.dataSource = rows;
        // 逗号后面添加一个空格， 为了让以单词换行
        rows.forEach((row: any) => {
          row.roleNameList && (row.roleNameList = row.roleNameList.replaceAll(',', ', '));
        });
        this.pagination.total = total;
      }
      this.isSpinning = false;
    });
  }

  onEdit(row: any) {
    this.isSpinning = true;
    this.service.addOrUpdate(row).subscribe(result => {
      const { rtnCode } = result;
      if (rtnCode === 10000) {
        this.getList();
        this.message.create('success', this.translate.instant('OPERATION_SUCCESS'));
      }
      this.isSpinning = false;
    });
  }

  onDelete(row: any) {
    this.isSpinning = true;
    this.service.delete(row.id).subscribe(result => {
      const { rtnCode } = result;
      if (rtnCode === 10000) {
        this.getList();
        this.message.create('success', this.translate.instant('OPERATION_SUCCESS'));
      }
      this.isSpinning = false;
    });
  }

  pageSizeChange(pageSize: number) {
    this.pagination.pageSize = pageSize;
    this.getList();
  }

  pageIndexChange(pageIndex: number) {
    this.pagination.pageIndex = pageIndex;
    this.getList();
  }

  onEditUser(row: any) {
    const { name, department, ntAccount, roleIdList, email, id } = row;
    this.validateModuleForm.setValue({
      name, department, ntAccount, roleIds: roleIdList ? roleIdList.split(',') : [], email, id
    });
    this.isVisible = true;
  }

  onSave() {
    if (this.validateModuleForm.valid) {
      this.isVisible = false;
      const params = {
        ntAccount: this.validateModuleForm.get('ntAccount')?.value,
        name: this.validateModuleForm.get('name')?.value,
        ...this.validateModuleForm.value,
      }
      this.onEdit(params);
    } else {
      Object.values(this.validateModuleForm.controls).forEach(control => {
        if (control.invalid) {
          control.markAsDirty();
          control.updateValueAndValidity({ onlySelf: true });
        }
      });
    }
  }

  onCancel() {
    this.validateModuleForm.reset();
    this.isVisible = false;
  }

}
